import React from "react";

const ExplainFactor = ({ text }) => {
  return (
    <>
      <p className="">{text}</p>
    </>
  );
};

export default ExplainFactor;
